export default {
  // 顶部导航
  nav: {
    title: '我的',
  },

  // 用户信息卡片
  userCard: {
    cancer: '巨蟹座',
    soulNumber: '靈魂數字',
    receiveCharm: '領取能量卡',
  },

  // 统计数据
  stats: {
    analysisCount: '解析次數',
    charmCollection: '能量卡收藏',
    divinationRecord: '占卜記錄',
    moodRecord: '心情記錄',
  },

  // 未登录态
  notLoggedIn: {
    loginNow: '立即登錄',
    loginTip: '登錄享受完整功能',
    featureTip: '登錄享受完整功能',
  },

  // 充值横幅
  rechargeBanner: {
    title: '我要充值',
    subtitle: '金幣充值 · 解鎖更多功能',
    button: '立即充值',
  },

  // 菜单部分
  menu: {
    myServices: {
      title: '我的服務',
      member: '我的會員',
      coins: {
        label: '我的金幣',
        value: '金幣',
      },
      spirit: '我的靈力值',
      charms: '我的能量卡',
    },
    management: {
      title: '管理與設置',
      fileManage: '檔案管理',
      subscription: '訂閱設置',
      preferences: '偏好設置',
    },
    support: {
      title: '支持與聯繫',
      reward: '打賞支持',
      invite: '邀請好友',
      service: '聯繫客服',
    },
    other: {
      title: '其他',
      version: '版本信息',
      versionValue: 'v1.2  最新版本',
      terms: '服務使用條款',
      privacy: '隱私政策',
    },
  },

  // 退出登录
  logout: '退出登錄',

  // 版本信息弹窗
  versionModal: {
    appName: '命理乾坤',
    latestBadge: '已是最新版本',
    updateTitle: 'v1.2 更新內容',
    copyright: '© 2026 命理乾坤 · 保留所有權利',
    rows: {
      currentVersion: '當前版本',
      versionType: '版本類型',
      releaseType: '正式版',
      releaseDate: '發佈日期',
      packageSize: '包大小',
      minSystem: '最低系統',
    },
    logs: [
      '新增「今日穿搭」AI能量推薦功能',
      '優化命盤計算算法，提升準確度',
      '修復部分設備顯示異常問題',
      '改善應用啟動速度',
    ],
  },

  // 账号编辑弹窗
  accountEdit: {
    title: '編輯資料',
    save: '儲存修改',
    saveSuccess: '儲存成功',
    tabs: {
      basic: '基本資訊',
      contact: '聯絡方式',
      login: '登入方式',
    },
    avatar: {
      tip: '點擊頭像下方按鈕更換頭像',
      presetTitle: '選擇預設頭像',
      upload: '從相冊上傳',
    },
    basic: {
      nickname: '昵稱',
      nicknamePlaceholder: '請輸入昵稱',
      bio: '個性簽名',
      bioPlaceholder: '寫點什麼介紹自己吧...',
      gender: '性別',
      female: '女',
      male: '男',
      other: '保密',
    },
    contact: {
      tip: '聯絡方式僅用於帳號找回，不會公開顯示',
      email: '郵筱',
      emailPlaceholder: '請輸入郵筱地址',
      phone: '手機號',
      phonePlaceholder: '請輸入手機號',
      wechat: '微信號',
      wechatPlaceholder: '請輸入微信號',
    },
    login: {
      title: '登入方式綁定',
      tip: '綁定多種登入方式，保障帳號安全',
      phone: '手機號登入',
      email: '郵箱登入',
      apple: 'Apple 登入',
      google: 'Google 登入',
      bound: '已綁定',
      unbound: '未綁定',
      bind: '綁定',
      unbind: '解綁',
      changePassword: '修改密碼',
      deleteAccount: '注銷帳號',
    },
  },

  // 充值弹窗
  rechargeModal: {
    title: '金幣充值',
    currentBalance: '當前餘額',
    coins: '金幣',
    packages: {
      starter: '入門包',
      hot: '熱門',
      value: '超值包',
      premium: '尊享包',
    },
    confirmButton: '立即充值',
  },
};